var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "cvadjustcompetences" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between mb-3" },
        [
          _c("b-card-title", { staticClass: "h5 mb-0" }, [
            _vm._v(_vm._s(_vm.t.CV_Tool_Adjust_Competences_Title)),
          ]),
          _c("InfoToolTip", {
            attrs: { content: _vm.t.CV_Tool_Adjust_Competences_Title_Tooltip },
          }),
          _c(
            "b-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: {
                    content: _vm.t.CV_Tool_Profile_Link_Tooltip,
                    container: false,
                  },
                  expression:
                    "{ content: t.CV_Tool_Profile_Link_Tooltip, container: false }",
                  modifiers: { bottom: true },
                },
              ],
              staticClass:
                "text-brand-medium font-weight-bold text-decoration-none",
              style: { height: "fit-content" },
              attrs: { href: _vm.profileLink },
              on: { click: _vm.goToProfile },
            },
            [
              _vm._v(
                _vm._s(_vm.t.general_Add) + " / " + _vm._s(_vm.t.general_Edit)
              ),
            ]
          ),
        ],
        1
      ),
      _c("b-card-text", { staticClass: "text-muted" }, [
        _vm._v(_vm._s(_vm.t.CV_Tool_Adjust_Competences_Description)),
      ]),
      _vm.items === undefined
        ? _c("div", { staticClass: "waiting" }, [
            _vm._v(_vm._s(_vm.t.CV_Tool_Adjust_Competences_Waiting)),
          ])
        : _vm._e(),
      !_vm.validCompetences ||
      _vm.validCompetences.indexOf("COMPETENCES_PROFESSIONAL") !== -1
        ? _c("DisplaySkills", {
            attrs: {
              title: _vm.t.CV_Tool_Adjust_Competences_Professional_Title,
              items: _vm.items.competences,
              type: "ProfessionalCompetences",
              itemProp: "text",
              profileLink:
                _vm.competencesLink === undefined
                  ? _vm.profileLink
                  : _vm.competencesLink,
              tooltip: _vm.t.CV_Tool_Skill_Item_Tooltip,
            },
            on: {
              toggleItem: function ($event) {
                return _vm.toggleItem($event)
              },
            },
          })
        : _vm._e(),
      !_vm.validCompetences ||
      _vm.validCompetences.indexOf("COMPETENCES_PERSONAL") !== -1
        ? _c("DisplaySkills", {
            attrs: {
              title: _vm.t.CV_Tool_Adjust_Competences_Personal_Title,
              items: _vm.items.personalCompetences,
              type: "PersonalCompetences",
              itemProp: "title",
              profileLink: _vm.profileLink,
              tooltip: _vm.t.CV_Tool_Skill_Item_Tooltip,
            },
          })
        : _vm._e(),
      !_vm.validCompetences ||
      _vm.validCompetences.indexOf("SKILLS_LANGUAGE") !== -1
        ? _c("DisplaySkills", {
            attrs: {
              title: _vm.t.CV_Tool_Adjust_Competences_Language,
              items: _vm.items.skills.languages,
              type: "Languages",
              itemProp: "Text",
              profileLink: _vm.profileLink,
              tooltip: _vm.t.CV_Tool_Skill_Item_Tooltip,
            },
          })
        : _vm._e(),
      !_vm.validCompetences || _vm.validCompetences.indexOf("SKILLS_IT") !== -1
        ? _c("DisplaySkills", {
            attrs: {
              title: _vm.t.CV_Tool_Adjust_Competences_IT_Competences,
              items: _vm.items.skills.itSkills,
              type: "ItSkills",
              itemProp: "Text",
              profileLink: _vm.profileLink,
              tooltip: _vm.t.CV_Tool_Skill_Item_Tooltip,
            },
          })
        : _vm._e(),
      !_vm.validCompetences ||
      _vm.validCompetences.indexOf("SKILLS_LICENSE") !== -1
        ? _c("DisplaySkills", {
            attrs: {
              title: _vm.t.CV_Tool_Adjust_Competences_DriverLicense,
              items: _vm.items.skills.driverLicenses,
              type: "Licenses",
              profileLink: _vm.profileLink,
              itemProp: "Text",
              tooltip: _vm.t.CV_Tool_Skill_Item_Tooltip,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }